import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value:any, ...args:any): any {
    const resultDocs=[];
    for(const doc of value){
      if(doc.name.indexOf(args) > -1){
        resultDocs.push(doc)
      }
    }
    return resultDocs
  }

}
